import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { isContentstackEnabled } from 'yoda-site-components/lib/cms-renderer/utils';
import Iris from './Iris';
import Contentstack from './Contentstack';

/**
 * Home — Entry point / Switcher.
 * Checks feature flag and routes to Iris or Contentstack.
 * Both are parallel. No interconnection.
 */
function Home(props) {
    const { enableContentstackCMS, contentstackPageList, location } = props;

    if (isContentstackEnabled(enableContentstackCMS, location, contentstackPageList)) {
        return <Contentstack {...props} />;
    }

    return <Iris {...props} />;
}

const mapStateToProps = ({ context }) => {
    const featureFlags = _get(context, 'featureFlags', {});
    const preferences = _get(context, 'preferences', {});

    return {
        enableContentstackCMS: featureFlags.enableContentstackCMS || false,
        contentstackPageList: _get(preferences, 'contentstackPageList', []),
    };
};

export default connect(mapStateToProps)(Home);
